<template>
  <md-input
    v-model="input"
    data-vv-name="address"
    type="text"
    name="address"
    required
  >
  </md-input>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      address: {
        house_number: "",
        road: "",
        neighbourhood: "",
        suburb: "",
        town: "",
        state: "",
        postcode: "",
        country: "",
        country_code: ""
      },
      lat: "",
      lon: "",
      timer: null,
      disableLookup: false
    };
  },
  props: ["value"],
  methods: {
    init() {
      this.disableLookup = true;
      this.processValue(this.value);
    },
    processValue(val) {
      this.input = val.address;
      this.lat = val.lat;
      this.lon = val.lng;
    },
    lookup() {
      if (this.disableLookup === true) {
        return;
      }
      this.$http
        .get(
          "https://nominatim.openstreetmap.org/search.php?q=" +
            this.input +
            "&limit=1&format=jsonv2&addressdetails=1"
        )
        .then(
          response => {
            if (response.data.length !== 1) {
              return;
            }

            this.address = this.getAddressFromData(
              response.data[0].address,
              this.input
            );
            this.lat = Number(response.data[0].lat);
            this.lon = Number(response.data[0].lon);

            this.$emit("input", {
              address: this.input,
              lat: this.lat,
              lng: this.lon
            });
          },
          response => {}
        );
    },
    getAddressFromData(data, inputAddress) {
      if (data.hasOwnProperty("village")) {
        return data.road + " " + data.house_number + " " + data.village;
      }
      if (data.hasOwnProperty("town")) {
        return data.road + " " + data.house_number + " " + data.town;
      }
      if (data.hasOwnProperty("city")) {
        return data.road + " " + data.house_number + " " + data.city;
      }

      return inputAddress;
    }
  },
  watch: {
    input() {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      if (this.disableLookup === false) {
        this.timer = setTimeout(this.lookup, 1000);
      }
      this.disableLookup = false;
    },
    value: {
      handler(val, oldVal) {
        if (
          oldVal.address === "" &&
          val.address !== "" &&
          oldVal.lat === "" &&
          val.lat !== "" &&
          oldVal.lng === "" &&
          val.lng !== ""
        ) {
          this.disableLookup = true;
        } else {
          this.disableLookup = false;
        }

        this.processValue(val);
      }
    }
  },
  created() {
    this.init();
  }
};
</script>
<style></style>
